import React, { useState, useRef } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const SkeletonTable = ({
  columns = [],
  searchingFields = [],
  data = [],
  isLoading,
  pagination = false,
  handleTableChange = () => {},
  onRowClick = () => {},
  index = true,
}) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [paginationConfig, setPaginationConfig] = useState({
    current: 1,
    pageSize: 10,
  });

  const numberColumn = {
    title: "No.",
    dataIndex: "no",
    render: (_, __, index) => {
      const { current, pageSize } = paginationConfig;
      return (current - 1) * pageSize + index + 1;
    },
    width: 80,
  };

  const newColumns = index ? [numberColumn, ...columns] : columns;

  // ---------- Column wise search functionality ------------ //
  const handleSearchInter = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div className="p-2" onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearchInter(selectedKeys, confirm, dataIndex)
          }
          className="block mb-2"
        />
        <Space>
          <Button
            type="primary"
            size="small"
            className="w-[90px]"
            icon={<SearchOutlined />}
            onClick={() => handleSearchInter(selectedKeys, confirm, dataIndex)}
          >
            Search
          </Button>
          <Button
            size="small"
            className="w-[90px]"
            onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          >
            Reset
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#0BAFD4" : "#000000",
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value?.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const updatedColumns =
    searchingFields.length > 0
      ? newColumns.map((column) => {
          let array = searchingFields;
          if (array.includes(column.dataIndex)) {
            return {
              ...column,
              ...getColumnSearchProps(column.dataIndex),
            };
          }
          return column;
        })
      : newColumns;

  return (
    <Table
      className="table-responsive"
      columns={updatedColumns}
      dataSource={data}
      loading={isLoading}
      sortDirections={false}
      pagination={pagination}
      onChange={(pagination) => {
        handleTableChange(pagination);
        setPaginationConfig(pagination);
      }}
      onRow={(record) => {
        return {
          onClick: () => onRowClick(record),
          style: { cursor: 'pointer' }
        };
      }}
    />
  );
};

export default SkeletonTable;
